import { HStack, Stack, VStack } from '@chakra-ui/react';
import { Header } from './Header/index';
import Logo from './Logo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DefaultHeader = function DefaultHeader(_ref) {
  var showLogo = _ref.showLogo,
      _ref$showBannerTitle = _ref.showBannerTitle,
      showBannerTitle = _ref$showBannerTitle === void 0 ? true : _ref$showBannerTitle;
  return /*#__PURE__*/_jsx(VStack, {
    w: "full",
    e2eid: "components_DefaultHeader_VStack",
    children: /*#__PURE__*/_jsxs(HStack, {
      w: "full",
      h: "60px",
      justify: "center",
      bgColor: "white",
      boxShadow: "sm",
      zIndex: "banner",
      e2eid: "components_DefaultHeader_HStack",
      children: [showLogo && /*#__PURE__*/_jsx(Stack, {
        w: "120px",
        h: "full",
        justify: "center",
        align: "center",
        e2eid: "components_DefaultHeader_Stack",
        children: /*#__PURE__*/_jsx(Logo, {
          e2eid: "components_DefaultHeader_Logo"
        })
      }), /*#__PURE__*/_jsx(Header, {
        hasNotification: true,
        hasAiSuggestion: true,
        showBannerTitle: showBannerTitle,
        e2eid: "components_DefaultHeader_Header"
      })]
    })
  });
};

export default DefaultHeader;